import React from "react";
import {Table} from "react-bootstrap";
import {formatNumber} from "../Statistics/format.js";
import NutzungWidget from "./NutzungWidget.jsx";

/**
 * Geräte-Übersicht des Mitarbeiters. Die genaue Feldform stand in der
 * Spezifikation nicht fest - der Backend-Abgleich hat sich für die
 * deutschen Feldnamen der übrigen Auswertung entschieden: geraet, browser,
 * plattform, sitzungen (siehe App\Services\Activity\ActivityQuery::geraeteFuer()).
 */
export default function NutzungProfilGeraete({geraete, loading, error}) {
    const rows = Array.isArray(geraete) ? geraete : [];

    return (
        <NutzungWidget
            title="Geräte"
            help="Verwendete Geräte, Browser und Plattformen im gewählten Zeitraum."
            loading={loading}
            error={error}
            empty={!loading && !error && rows.length === 0}
            height={240}
        >
            <Table size="sm" className="align-middle mb-0">
                <thead>
                    <tr>
                        <th>Gerät</th>
                        <th>Browser</th>
                        <th>Plattform</th>
                        <th className="text-end">Sitzungen</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, index) => (
                        <tr key={index}>
                            <td>{row.geraet || "–"}</td>
                            <td>{row.browser || "–"}</td>
                            <td>{row.plattform || "–"}</td>
                            <td className="text-end">{formatNumber(row.sitzungen)}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </NutzungWidget>
    );
}
